import * as React from 'react';

const Search16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.006 7.003a5.97 5.97 0 0 1-1.265 3.677l2.728 2.729a.75.75 0 0 1-1.06 1.06l-2.73-2.729a5.97 5.97 0 0 1-3.676 1.266 6.004 6.004 0 1 1 6.003-6.003M2.5 7c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5S9.481 2.5 7 2.5A4.505 4.505 0 0 0 2.5 7",
    clipRule: "evenodd"
  }
));
Search16.Size = 16;
Search16.Title = "Search";

export { Search16 as default };
